import { atom, ExtractAtomValue } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { parseAsBoolean, useQueryState } from 'nuqs';

import type {
  ContentReference,
  SearchDocument as Document,
} from '@/_generated/api-clients/xp';

export const documentTransientAtom = atomWithReset({
  isTranslating: false,
  chosenLinkDocument: null as Document | null,
  chosenDocumentCountry: null as ContentReference['country'] | null,
  chosenCountryTab: null as ContentReference['country'] | null,
});

export const toggleTranslationAtom = atom(null, (get, set) => {
  const prev = get(documentTransientAtom);
  set(documentTransientAtom, {
    ...prev,
    isTranslating: !prev.isTranslating,
  });
});

export const setChosenCountryTabAtom = atom(
  null,
  (get, set, value: ContentReference['country'] | null) => {
    set(documentTransientAtom, {
      ...get(documentTransientAtom),
      chosenCountryTab: value,
    });
  },
);

export const setChosenDocumentCountryAtom = atom(
  null,
  (get, set, value: ContentReference['country'] | null) => {
    set(documentTransientAtom, {
      ...get(documentTransientAtom),
      chosenDocumentCountry: value,
    });
  },
);

/** Direct partial update atom (like adminAtom pattern). */
export const updateDocumentTransientAtom = atom(
  null,
  (
    get,
    set,
    partial: Partial<ExtractAtomValue<typeof documentTransientAtom>>,
  ) => {
    set(documentTransientAtom, {
      ...get(documentTransientAtom),
      ...partial,
    });
  },
);

export const useGameFullscreen = () =>
  useQueryState('gameFullscreen', parseAsBoolean.withDefault(false));
